import cx from "classnames";
import type { FunctionComponent } from "react";
import { memo, useRef } from "react";
import { Text } from "@smartsuite/react-ui/lib";
import type { ColumnKeyFunc, Side } from "@smartsuite/grid/lib/types";
import type { ActionChangeGridHeadCellWidth } from "@smartsuite/grid/lib/components/GridHeadCell/GridHeadCell";
import { GridHeadCell } from "@smartsuite/grid/lib/components/GridHeadCell/GridHeadCell";
import type { AppField } from "@smartsuite/smartsuite-client";

import { automationsActivityRenders } from "../../../AutomationActivity.contants";

interface ActivityGridHeadCellProps {
  side: Side;
  field: AppField;
  width: number;
  getColumnKey: ColumnKeyFunc<AppField>;

  onWidthChange?: (
    field: AppField,
    width: number,
    action: ActionChangeGridHeadCellWidth,
  ) => void;
}

const ActivityGridHeadCellRaw: FunctionComponent<ActivityGridHeadCellProps> = ({
  side,
  field,
  width,
  getColumnKey,
  ...props
}) => {
  const headCellRef = useRef<HTMLDivElement>(null);
  const { isCentered } = automationsActivityRenders[field.field_type];

  const classes = cx(
    "r-grid-head-cell--self-resize-hover",
    "activity-grid-head-cell",
    { "is-centered": isCentered },
  );

  return (
    <GridHeadCell
      {...props}
      ref={headCellRef}
      className={classes}
      column={field}
      width={width}
      side={side}
      // @ts-expect-error
      getColumnKey={getColumnKey}
    >
      <Text
        styles={{ minWidth: width }}
        className="activity-grid-head-cell__text"
        weight="medium"
        size="s"
      >
        {field.label}
      </Text>
    </GridHeadCell>
  );
};

export const ActivityGridHeadCell = memo(ActivityGridHeadCellRaw);
